import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

// @Component({
//   selector: 'app-domainsectionectionnew',
//   templateUrl: './domainsectionectionnew.component.html',
//   styleUrls: ['./domainsectionectionnew.component.scss']
// })

@Component({
  selector: "app-domainsettingsectionnew",
  templateUrl: "./domainsettingsectionnew.component.html",
  styleUrls: ["./domainsettingsectionnew.component.scss"],
})
export class domainsectionectionnewComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  dataSource: "";
  domainsection: any;
  displayedColumns: string[] = [
    "action",
    "name",
    "label",
    "sortorder",
    "description",
  ];
  domainkey: string = "";
  domainkeys: string = "";
  domainid: string = "";
  constructor(
    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.getDomainsectionlist();

    this.domainkey = this.route.snapshot.paramMap.get("domainkey") || "";

    this.domainkeys = this.route.snapshot.params.domainkey; // 'Account'
    this.domainid = this.route.snapshot.params.id;

    console.log("domainkeys", this.domainkeys);
    console.log("domainid", this.domainid);
  }

  goToDomainfields(section: string, element: any) {
    this.router.navigateByUrl(
      `/home/domainfieldslist/${section}/` + element.id
    );
  }

  cancel() {
    this.router.navigateByUrl("home/domainsettinglist");
  }

  // new() {
  //     this.router.navigateByUrl("home/domainsection/new ");
  // }

  // new(domainkey: string, id: string) {
  //   this.router.navigateByUrl(`/home/domainsection/new/${domainkey}/${id}`);
  // }

  new() {
    // const domainkey = this.route.snapshot.paramMap.get('domainkey');
    // const id = this.route.snapshot.paramMap.get('id');
    this.router.navigateByUrl(
      `/home/domainsection/new/${this.domainkey}/${this.domainid}`
    );
  }

  //  editApp(element: any ) {
  //   this.router.navigateByUrl('/home/domainsection/edit/' + element.id)
  // }

  editApp(element: any) {
    this.router.navigateByUrl(
      `/home/domainsection/edit/${this.domainkey}/${this.domainid}/${element.id}`
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  delete(id: any, type: any) {
    // alert(id)
    // const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteDomainSettingSection(id, type, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")

            this.showSuccess(res.message);
            this.isLoading = false;

            // window.location.reload();
            this.getDomainsectionlist();
          } else {
            console.log("Failed to delete!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  getDomainsectionlist() {
    return new Promise((resolve, reject) => {
      console.log("getDomainSettingsection");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      const id = this.route.snapshot.paramMap.get("id");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      console.log("org id", organizationid);
      console.log("domain", domain);
      console.log("subdomain", subdomain);
      this.isLoading = true;
      this.dataService

        .getAllDomainSettingSection(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.domainsection = res.data.domainsettingsection;
              console.log("Doneeee****", this.domainsection);

              if (this.domainsection != null) {
                this.dataSource = this.domainsection.map((domainsection) => ({
                  id: domainsection.id,
                  name: domainsection.name,
                  label: domainsection.label,
                  sortorder: domainsection.sortorder,
                  description: domainsection.description,
                  // active: domainsection.active,

                  // modifieddate: convertsetting.modifieddate,
                  // createdby: convertsetting.createdby,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
}
